"use strict";

angular.module("core").directive("compareTo", function() {
    return {
        require: "ngModel",
        scope: {
            otherModelValue: "=compareTo"
        },
        link: function(scope, element, attributes, ngModel) {
            ngModel.$validators.compareTo = function(modelValue) {
                return modelValue == scope.otherModelValue;
            };
            scope.$watch("otherModelValue", function() {
                ngModel.$validate();
            });
        }
    };
})



//////////////////
// WEBPACK FOOTER
// ./core/compare-to/compare-to.directive.js
// module id = 488
// module chunks = 0